module.exports = __webpack_public_path__ + "img/icons-zhpj-hdpj.014c5976.png";